import * as i0 from "@angular/core";
export class ButtonStore {
}
ButtonStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ButtonStore_Factory() { return new ButtonStore(); }, token: ButtonStore, providedIn: "root" });
export var ButtonStoreKeys;
(function (ButtonStoreKeys) {
})(ButtonStoreKeys || (ButtonStoreKeys = {}));
